/**
 * HomeENDemoPeopleContentView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait HomeENDemoPeopleContent
 */

import { useHomeENDemoPeopleContentLogic } from '@/hooks/traits/useHomeENDemoPeopleContentLogic';
import type { HomeENDemoPeopleContentConfig } from '@/hooks/traits/useHomeENDemoPeopleContentLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { HomeENDemoPeopleLeave } from '@app/shared';
import { HomeENDemoPeopleStatsView } from '@/components/traits/HomeENDemoPeopleStatsView';
import { Stack } from '@almadar/ui/components';
import { HomeENDemoPeopleCalendarView } from '@/components/traits/HomeENDemoPeopleCalendarView';
import { Typography } from '@almadar/ui/components';
import { HomeENDemoPeopleTypeChartView } from '@/components/traits/HomeENDemoPeopleTypeChartView';
import { Split } from '@almadar/ui/components';
import { Card } from '@almadar/ui/components';
import { UISlotComponent, renderPatternValue } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface HomeENDemoPeopleContentViewProps {
  config?: Partial<HomeENDemoPeopleContentConfig>;
}

export function HomeENDemoPeopleContentView({ config: propsConfig }: HomeENDemoPeopleContentViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useHomeENDemoPeopleContentLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['HomeENDemoPeopleLeave'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="HomeEN" trait="HomeENDemoPeopleContent">
      {slotWriter['main'] === 'INIT' ? (<Stack className="p-5" gap="md" direction="vertical"><Stack direction="vertical" gap="none"><Typography content={renderPatternValue(__t("std-almadar-demo-people-page:page.title"))} variant="h3" /><Typography variant="small" color="muted" content={renderPatternValue(__t("std-almadar-demo-people-page:page.subtitle"))} /></Stack><Split ratio="3:1" gap="md"><Card padding="sm"><HomeENDemoPeopleCalendarView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Card><Stack gap="md" direction="vertical"><HomeENDemoPeopleStatsView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Card padding="sm"><HomeENDemoPeopleTypeChartView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Card></Stack></Split></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default HomeENDemoPeopleContentView;
